import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Controls } from "../services/constants/constantsControl";
import { getGuidScreenByRoute } from "../services/utils";
import { userIsAdmin, userIsInsurer } from "../services/utilsUser";
import { ApplicationState } from "../store";

export interface EvidenceAccess {
	canView: boolean;
	canUpload: boolean;
	guidScreen: string;
}

function useEvidenceAccess(): EvidenceAccess {
	const { pathname } = useLocation();
	const { controlsByScreen } = useSelector((state: ApplicationState) => state.control);

	const controls = controlsByScreen.data ?? [];
	const hasControl = (elementId: string) => controls.some((control) => control.elementId === elementId);

	const canView = userIsAdmin() || userIsInsurer();

	return {
		canView,
		canUpload: canView && hasControl(Controls.IdUploadEvidence),
		guidScreen: getGuidScreenByRoute(pathname),
	};
}

export default useEvidenceAccess;
